
import PercentageCircle from "../../../assets/filled/PercentageCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PercentageCircleIcon({ className, dataTestid = "PercentageCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <PercentageCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
